import styled from '@emotion/styled'
import {SearchInput} from '../../core/shared/SearchInput'

export const StyledSearch = styled(SearchInput)`
  .search-field-row {
    border-radius: 5px;
  }
`

export const Wrapper = styled.div`
  width: 100%;
`
